module.exports = __webpack_public_path__ + "399aaa17e1f6eadcdbafd3a5817f29e6.png";